import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia, Button } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  get_30DaysBack_FromCurrentDate,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiFarmerURL, fetchFarmerBillDetail } from "./API";
import ResetDate from "../images/resetdate.png";
import CtCmb from "./CustomTool/CtCmb";
import CtTxt from "./CustomTool/CtTxt";
import CtTxtNum from "./CustomTool/CtTxtNum";

class KhedutBillPrint extends Component {
  state = {
    formData: {
      dtpFromDate: get_30DaysBack_FromCurrentDate(new Date()),
      dtpToDate: get_YMD_from_SYS(new Date()),
      cmbType: "Inward No Wise",
      txtFromInwardNo: "",
      txtToInwardNo: "",
      dateHide: true,
      inwardHide: false,
    },
    Types: [{ type: "Date Wise" }, { type: "Inward No Wise" }],
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : ખેડૂત બિલ પ્રિન્ટ";
    this.props.setActiveMenu("KhedutBillPrint");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        if (e.target.name == "cmbType") {
          let dateHide = this.state.formData.dateHide,
            inwardHide = this.state.formData.inwardHide;
          if (e.target.value == "Date Wise") {
            inwardHide = true;
            dateHide = false;
          } else if (e.target.value == "Inward No Wise") {
            dateHide = true;
            inwardHide = false;
          }
          this.setState({
            formData: {
              ...this.state.formData,
              dateHide,
              inwardHide,
            },
          });
        }
      }
    );
  };

  //#endregion Handles

  //#region Function

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chekNewpage"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validateFromToDate = () => {
    let result = false;

    // Validation only triggered when print is clicked
    if (this.state.formData.cmbType === "Date Wise") {
      let result = false;
      if (this.state.formData.dtpFromDate.length <= 0) {
        this.props.toastErrorMsg("તારીખ ઉમેરો", "dtpFromDate");
      } else if (
        validatedate_min_max(
          this.state.formData.dtpFromDate,
          "dtpFromDate",
          this.props.toastErrorMsg
        ) == false
      ) {
        return result;
      } else if (this.state.formData.dtpToDate.length <= 0) {
        this.props.toastErrorMsg("થી તારીખ ઉમેરો", "dtpToDate");
      } else if (
        validatedate_min_max(
          this.state.formData.dtpToDate,
          "dtpToDate",
          this.props.toastErrorMsg
        ) == false
      ) {
        return result;
      } else {
        result = true;
      }
      return result;
    } else if (this.state.formData.cmbType === "Inward No Wise") {
      if (
        (!this.state.formData.txtFromInwardNo ||
          Number(this.state.formData.txtFromInwardNo) <= 0) &&
        (!this.state.formData.txtToInwardNo ||
          Number(this.state.formData.txtToInwardNo) <= 0)
      ) {
        // Only show this error when print is clicked
        this.props.toastErrorMsg(
          "યોગ્ય ઇનવર્ડ નંબર અને થી ઇનવર્ડ નંબર દાખલ કરો",
          "txtFromInwardNo"
        );
      } else if (
        !this.state.formData.txtFromInwardNo ||
        Number(this.state.formData.txtFromInwardNo) <= 0
      ) {
        this.props.toastErrorMsg("ઇનવર્ડ નંબર દાખલ કરો", "txtFromInwardNo");
      } else if (
        !this.state.formData.txtToInwardNo ||
        Number(this.state.formData.txtToInwardNo) <= 0
      ) {
        this.props.toastErrorMsg("થી ઇનવર્ડ નંબર દાખલ કરો", "txtToInwardNo");
      } else if (
        this.state.formData.txtFromInwardNo > this.state.formData.txtToInwardNo
      ) {
        // If from is greater than to
        this.props.toastErrorMsg(
          "યોગ્ય ઇનવર્ડ નંબર દાખલ કરો",
          "txtFromInwardNo"
        );
      } else {
        result = true;
      }
    }
    return result;
  };

  onFormLoad = () => {
    this.props.notifyProcessing();
    document.getElementById("txtFromInwardNo").focus();
    this.props.closeUpdateProcessing();
  };

  prepareKhedutRequestData = (bolChkDataExist) => {
    const { formData } = this.state;
    return {
      Op: "KhedutMultipleBillPrint",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      bint_inwardnofrom:
        Number(formData.txtFromInwardNo) > 0 ? formData.txtFromInwardNo : 0,
      bint_inwardnoto:
        Number(formData.txtToInwardNo) > 0 ? formData.txtToInwardNo : 0,
      dat_datefrom: formData.dtpFromDate,
      dat_dateto: formData.dtpToDate,
      GenerateBillType: formData.cmbType === "Date Wise" ? "Date" : "InwardNo",
      bolChkDataExist: bolChkDataExist,
    };
  };

  convertObjectToQueryString = (obj) => {
    return Object.entries(obj)
      .map(
        ([key, value]) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(value)
      )
      .join("&");
  };

  openInvoiceKhedut = () => {
    if (this.validateFromToDate()) {
      this.props.notifyProcessing();

      const reqDataCheck = this.prepareKhedutRequestData(true);

      fetchFarmerBillDetail(reqDataCheck)
        .then((res) => {
          const { msgType, message } = res.data || {};

          if (msgType === "info") {
            // Only open popup if data exists
            const reqDataPopup = this.prepareKhedutRequestData(false);
            const queryString = this.convertObjectToQueryString(reqDataPopup);
            const popupURL = `${apiFarmerURL}farmerbilldetail.php?${queryString}`;

            window.open(
              popupURL,
              "SalesList",
              `width=${window.screen.availWidth},height=${window.screen.availHeight}`
            );

            this.props.updateProcessing("success", "PDF Opened in popup.");
          } else if (msgType === "error") {
            // Show backend error (like "No Item Entry found for Inward No(s): 123")
            this.props.updateProcessing("error", message);
          } else {
            // Unknown case
            this.props.updateProcessing(
              "error",
              "Unknown response from backend."
            );
          }
        })
        .catch((error) => {
          console.error("Unknown error occurred in openInvoiceKhedut.", error);
          this.props.updateProcessing(
            "error",
            "Unknown error occurred while loading. " + error.message
          );
        });
    }
  };

  //#endregion Function

  render() {
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>ખેડૂત બિલ પ્રિન્ટ</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbType"
              label="પ્રકાર"
              items={this.state.Types}
              colID="type"
              value={this.state.formData.cmbType}
              handleOnChange={this.handleOnChange}
              width={200}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          {this.state.formData.dateHide == false ? (
            <>
              <Grid item>
                <CtDtp
                  id="dtpFromDate"
                  label="તારીખ*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  nextCtrlID="dtpToDate"
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="થી તારીખ*"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  accountYear={localStorage.getItem("ACY")}
                  defaultAction={this.openInvoiceKhedut}
                />
              </Grid>
            </>
          ) : (
            ""
          )}

          {this.state.formData.inwardHide == false ? (
            <>
              <Grid item>
                <CtTxtNum
                  id="txtFromInwardNo"
                  label="ઈનવર્ડ નં."
                  value={this.state.formData.txtFromInwardNo}
                  handleOnChange={this.handleOnChange}
                  width="140"
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="txtToInwardNo"
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtToInwardNo"
                  label="થી ઈનવર્ડ નં."
                  value={this.state.formData.txtToInwardNo}
                  handleOnChange={this.handleOnChange}
                  width="140"
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.openInvoiceKhedut}
                />
              </Grid>
            </>
          ) : (
            ""
          )}

          <Grid item marginTop={1}>
            {/* <CtBtn label="print" onClick={this.openInvoiceKhedut}  onKeyDown={this.props.onKeyDown}/> */}
            <Button
              variant="contained"
              onClick={() => this.openInvoiceKhedut()}
              color="primary"
              onKeyDown={this.props.onKeyDown}
            >
              print
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(KhedutBillPrint))));
